import { render } from "./ShowProducts.vue?vue&type=template&id=7c74d8ca"
import script from "./ShowProducts.vue?vue&type=script&lang=js"
export * from "./ShowProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__